import React, { useRef } from 'react';
import { Col, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { STORE } from '../redux-configs';
import { ACTIONS } from '../actions';
import { EmergencyHelper } from '../helpers';

const getShortStatus = (status) => {
    switch (status) {
        case 'pending':
            return 'Очікування';
        case 'inProgress':
            return 'В роботі';
        case 'finished':
            return 'Завершено';
        default:
            return '';
    }
};

const backendUrl = process.env.NX_BACKEND_URL,
    backendPort = process.env.NX_BACKEND_PORT;

export function DataTable(props) {
    const { map } = props;
    const tableRef = useRef(null);

    const dispatch = useDispatch();
    const { filteredEmergencies, selectedEmergency } = useSelector(STORE);

    const onEmergencyClick = (id: string): void => {
        map.closePopup();
        dispatch({
            type: ACTIONS.SET_SELECTED_EMERGENCY,
            payload: filteredEmergencies.find((e) => e.id === id),
        });
        window.scrollTo(0, 0);
    };

    const copyCoordsToClipboard = (
        e: React.MouseEvent<HTMLImageElement>,
        coords: string
    ): boolean => {
        e.stopPropagation();
        if (navigator.clipboard) {
            // WORKS ON LOCALHOST AND HTTPS ONLY :(
            navigator.clipboard.writeText(coords).then();
            setTimeout(() => document.body.click(), 2000);
        } else if (
            document.queryCommandSupported &&
            document.queryCommandSupported('copy')
        ) {
            const textarea = document.createElement('textarea');
            textarea.textContent = coords;
            textarea.style.position = 'fixed';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                return true;
            } catch (ex) {
                console.warn('Copy to clipboard failed.', ex);
                return false;
            } finally {
                document.body.removeChild(textarea);
                setTimeout(() => document.body.click(), 2000);
            }
        }
    };

    return (
        <Col className="col-12 table-col">
            <Table striped hover bordered responsive ref={tableRef}>
                <thead>
                    <tr>
                        <th>Дата</th>
                        <th>Ім'я</th>
                        <th>Номер телефону</th>
                        <th>Область</th>
                        <th>Координати</th>
                        <th>Точність, м</th>
                        <th>Батарея, %</th>
                        <th>Канал</th>
                        <th>Статус</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredEmergencies.map(emergency => {
                        return (
                            <tr
                                key={JSON.stringify(emergency)}
                                onClick={() => onEmergencyClick(emergency.id)}
                                className={
                                    emergency.id === selectedEmergency?.id
                                        ? 'active-row'
                                        : null
                                }
                            >
                                <td>
                                    {EmergencyHelper.prettifyDate(
                                        emergency.createdAt
                                    )}
                                </td>
                                <td>{emergency.user.medicalCard?.firstName}</td>
                                <td>{emergency.user.phone}</td>
                                <td>{emergency.state}</td>
                                <td>
                                    <div className="coords-cell">
                                        <p>{`${emergency.latitude}, ${emergency.longitude}`}</p>
                                        <OverlayTrigger
                                            trigger={'click'}
                                            placement="right"
                                            overlay={
                                                <Tooltip
                                                    id="button-tooltip"
                                                    {...props}
                                                >
                                                    Координати скопійовано до
                                                    буфера обміну!
                                                </Tooltip>
                                            }
                                            delay={200}
                                            rootClose={true}
                                        >
                                            <img
                                                src={`${backendUrl}:${backendPort}/copy-icon.png`}
                                                onClick={(e) =>
                                                    copyCoordsToClipboard(
                                                        e,
                                                        `${emergency.latitude}, ${emergency.longitude}`
                                                    )
                                                }
                                                alt="copy-icon"
                                                title="Скопіювати координати"
                                            />
                                        </OverlayTrigger>
                                    </div>
                                </td>
                                <td>{emergency.accuracy}</td>
                                <td>{emergency.battery}</td>
                                <td>{emergency.source}</td>
                                <td>{getShortStatus(emergency.status)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </Col>
    );
}
